import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/events`;
const token = localStorage.getItem("token");

/// GET
// Fonction pour récupérer tous les événements
export const getAllEvents = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allEvents`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des événements:", error);
    return [];
  }
};

// Fonction pour récupérer les événements par section
export const getEventsBySection = async (sectionId) => {
  try {
    const response = await axios.get(`${apiUrl}/sectionEvents/${sectionId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des événements par section:",
      error
    );
    return [];
  }
};

// Fonction pour récupérer un événement par son id
export const getEventById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/event/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération de l'événement:", error);
    return null;
  }
};

/// POST
// Fonction pour créer un nouvel événement
export const addEvent = async (event) => {
  try {
    const response = await axios.post(`${apiUrl}/addEvent`, event, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout d'un événement:", error);
    return null;
  }
};

// Upload image pour la catégorie 'events'
export const uploadImage = async (formData) => {
  try {
    const response = await axios.post(`${apiUrl}/uploadImage`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
        "x-category": "events", // Ajout du header pour spécifier 'events'
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'upload de l'image:", error);
    return null;
  }
};

/// PUT
// Fonction pour modifier un événement
export const updateEvent = async (event) => {
  try {
    const response = await axios.put(
      `${apiUrl}/updateEvent/${event.id}`,
      event,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification de l'événement:", error);
    return null;
  }
};

// Fonction pour uploader une image de l'événement
export const uploadEventImage = async (eventId, photo) => {
  const formData = new FormData();
  formData.append("image", photo);
  try {
    const response = await axios.patch(`${apiUrl}/${eventId}/photo`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'upload de l'image:", error);
  }
};

/// DELETE
// Fonction pour supprimer un événement
export const deleteEvent = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/deleteEvent/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression de l'événement:", error);
    return null;
  }
};
